import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GoogleAnalyticsService } from '../cookie-consent/service/google-analytics.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

declare const gtag: Function;

@Component({
    selector: 'app-cookie-consent',
    templateUrl: './cookie-consent.component.html'
})
export class CookieConsentComponent implements OnInit {

    public removeContainer = false;
    public isCookiePolicyPage = false;
    public subscription: Subscription;

    constructor(
        private router: Router,
        private googleAnalyticsService: GoogleAnalyticsService
    ) {
        // update visibility when GA service state changes
        this.subscription = this.googleAnalyticsService.getState().subscribe((state) => {
            this.removeContainer = state;
        });

        // keep track of the current route so we can hide the banner on the policy page
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.isCookiePolicyPage = event.urlAfterRedirects.startsWith('/politica-cookies');
            }
        });
    }

    ngOnInit() {
        // determine if we start on the policy page, hide if so
        this.isCookiePolicyPage = this.router.url.startsWith('/politica-cookies');

        if (this.getCookie('user_cookie_consent')) {
            this.removeContainer = true;
        } else {
            this.removeContainer = false;
            this.googleAnalyticsService.acceptedConsent = false;
        }
    }

    public manageCookieConsent(consent: boolean) {
        const date = new Date();
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        const expiration = 'expires=' + date.toUTCString();
        document.cookie = 'user_cookie_consent' + "=" + consent + ";" + expiration + ";path=/;secure";

        if (consent) {
            this.googleAnalyticsService.acceptedConsent = true;
            if (document.getElementById('analyticsScript')) {
                document.getElementById('analyticsScript').remove()
            }
            const script = document.createElement('script');
            document.head.prepend(script);
            script.setAttribute('id', 'analyticsScript');
            script.src = 'https://www.googletagmanager.com/gtag/js?id=G-PSRLNKV1XZ';
            script.async = true;

            script.onload = () => {
                (window as any).dataLayer = (window as any).dataLayer || [];
                function gtag(...args: any[]) {
                    (window as any).dataLayer.push(args);
                }
                (window as any).gtag = gtag;

                gtag('js', new Date());
                gtag('config', 'G-PSRLNKV1XZ', { 'send_page_view': true });

                this.router.events.subscribe(event => {
                    if (event instanceof NavigationEnd) {
                        gtag('config', 'G-PSRLNKV1XZ', {
                            'page_path': event.urlAfterRedirects,
                            'send_page_view': false
                        });
                    }
                });

                this.removeContainer = true;
            };

            document.head.appendChild(script);
        } else {
            this.googleAnalyticsService.acceptedConsent = false;
            this.deleteCookie('_ga');
            this.deleteCookie('_ga_BK2GGNEMZD');
            this.removeContainer = true;
        }
    }

    public getCookie(name: string) {
        const cookieArray: Array<string> = document.cookie.split(';');
        const cookieArrayLength: number = cookieArray.length;
        const cookieName = `${name}=`;
        let cookie: string;

        for (let i: number = 0; i < cookieArrayLength; i += 1) {
            cookie = cookieArray[i].replace(/^\s+/g, '');
            if (cookie.indexOf(cookieName) === 0) {
                if (cookie.includes('true')) {
                    this.googleAnalyticsService.acceptedConsent = true;
                } else {
                    this.googleAnalyticsService.acceptedConsent = false;
                }
                return true;
            }
        }
        return false;
    }

    public deleteCookie(cookieName: string) {
        const date = new Date();
        date.setTime(date.getTime() + (-24 * 60 * 60 * 1000));
        const expiration = 'expires=' + date.toUTCString();
        document.cookie = cookieName + "= ''" + ";" + expiration + ";path=/;";
        document.cookie = cookieName + "= ''" + ";" + expiration + ";domain=.gesvatec.com" + ";path=/";
    }
}
